import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../context/AuthContext";
import { Trophy } from "lucide-react";

export default function Leaderboard({ rallyId }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { axios.get(`${API}/paddock/rallies/${rallyId}/leaderboard`).then(r => setRows(r.data)).catch(() => {}); }, [rallyId]);
  return (
    <div className="rl-card p-6 max-w-3xl mx-auto" data-testid="fan-leaderboard">
      <h2 className="font-display font-bold text-2xl flex items-center gap-2 mb-4"><Trophy className="w-6 h-6 text-[#FF9F0A]" /> Classifica Fan</h2>
      {rows.length === 0 && <div className="text-slate-500 text-center py-6">Nessun punteggio ancora. Sii il primo!</div>}
      <div className="space-y-2">
        {rows.map(r => (
          <div key={r.user_id} data-testid={`fan-row-${r.pos}`}
            className={`flex items-center justify-between border rounded-lg px-4 py-3 ${r.pos === 1 ? "border-[#FF9F0A]/40 bg-[#FF9F0A]/5" : "border-white/5"}`}>
            <div className="flex items-center gap-4">
              <div className={`font-display font-black text-2xl w-10 ${r.pos === 1 ? "text-[#FF9F0A]" : r.pos <= 3 ? "text-slate-300" : "text-slate-600"}`}>P{r.pos}</div>
              <div className="font-semibold">{r.name}</div>
            </div>
            <div className="font-mono-rl text-lg font-bold">{r.points} <span className="text-xs text-slate-500">pts</span></div>
          </div>
        ))}
      </div>
    </div>
  );
}
